<template>
    <div class="float-left mr-2">
        <span class="text-primary">
            <i
                class="fa fa-download fa-lg icon-button"
                title="Download"
                @click.stop="downloadDocumento()"
            ></i>
        </span>
    </div>
</template>

<script>
import TiposMovimentosServicos from './TiposMovimentosServicos'

export default {
    props: {
        documento: {
            type: Object,
            default: () => ({})
        }
    },

    methods: {
        downloadDocumento() {
            this.$store.dispatch('addRequest')
            TiposMovimentosServicos.obterDocumento(this.documento).then(
                response => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro ao realizar download do arquivo!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(
                                response,
                                `Movimento_${
                                    this.documento.tipo
                                }_${this.documento.codMov.replace(
                                    '.',
                                    '-'
                                )}.xml`
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    }
}
</script>
